import React, { Component } from 'react';
import SearchContext from './context';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
// Routes
import Home from './components/Home';
import Err from './components/Error';
import { Wrapper } from './theme/MainTheme';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
 
class App extends Component {
  constructor(props){
    super(props);
    this.state = {
      width: window.innerWidth,
      heigth: window.innerHeight
    }
  }

  /* Life Cycle */

  componentDidMount(){
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {

  }

  /* Functions */

  updateWindowDimensions = () => {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }

  render() {
     return (
      <SearchContext.Provider value={this.state}>
        <BrowserRouter>
          <Wrapper style={{ width: '100%', height: 'auto', overflow: 'hidden' }} >
            <>
              <Navigation />
              <Switch>
                <Route path="/" component={Home} exact />
                <Route path="*" component={Err} />
              </Switch>
              <Footer />
            </>
          </Wrapper>
        </BrowserRouter>
      </SearchContext.Provider>
    );
  }
}

export default App;
